var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8134 100.403C78.4281 100.403 100.814 78.017 100.814 50.4022C100.814 22.7875 78.4281 0.401367 50.8134 0.401367C23.1987 0.401367 0.8125 22.7875 0.8125 50.4022C0.8125 78.017 23.1987 100.403 50.8134 100.403Z",
    fill: "url(#paint0_linear_3569_98757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3744 23.8208L100.813 53.8828C100.813 53.8828 100.083 89.5965 62.3288 99.0695L60.0569 99.5359C59.677 99.6136 59.2972 99.6807 58.9138 99.7373L56.9175 100.032L32.9806 73.3482L31.6273 72.3553L22.1543 58.0116L32.0319 51.7416L50.2994 69.4686L63.3429 57.5893C63.3429 57.5893 73.0686 45.4098 65.0142 38.5091L63.6503 32.209L70.3744 23.8208Z",
    fill: "url(#paint1_linear_3569_98757)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8949 30.7705C59.6778 29.2371 55.3653 30.4349 52.2983 34.0283C51.9149 34.4594 51.3885 34.6997 50.8125 34.6997C50.2384 34.6997 49.7101 34.4594 49.3267 34.0283C46.3075 30.4349 41.9473 29.2371 37.7302 30.7705C32.363 32.7828 28.7695 38.438 28.7695 44.8581C28.7695 54.7781 36.9634 61.1506 44.9188 67.2845C46.0213 68.099 47.076 68.9134 48.1289 69.7755C48.8957 70.3992 49.8532 70.6854 50.8125 70.6854C51.7718 70.6854 52.7294 70.3974 53.4961 69.7755C54.5986 68.9134 55.6533 68.0989 56.7539 67.235C64.6599 61.1011 72.8538 54.7763 72.8538 44.8564C72.8555 38.3885 69.2621 32.7351 63.8949 30.7705Z",
    fill: "#8F38EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0565 39.6909L76.373 42.2615",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7578 39.6909L25.4413 42.2615",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4075 72.7967L65.5137 67.9224",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0227 67.8662L32.2773 72.8536",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6777 58.552L28.3912 56.0469",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5689 58.552L72.8555 56.0469",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7773 28.1754L69.6959 23.3223",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0906 28.1754L32.1738 23.3223",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7282 26.4408L50.6328 20.2026",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7282 81.2911L50.6328 75.0547",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3569_98757",
    x1: 50.8134,
    y1: 0.401367,
    x2: 50.8134,
    y2: 100.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F7F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3569_98757",
    x1: 89.0002,
    y1: 85.5,
    x2: 56.0002,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA8FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteEmptyState);
export default __webpack_public_path__ + "static/media/FavouriteEmptyState.bf93b598886ebf6d3c5822c549f0a9fe.svg";
export { ForwardRef as ReactComponent };